var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-management"},[_c('keep-alive',[_c('router-view',{staticClass:"router-project-management-top-section",attrs:{"name":"top-section"}})],1),_c('router-view',{staticClass:"router-project-management-main",class:[
      { 'is-paddingless': _vm.$route.name.includes('-vault') },
      { 'is-paddingless my-20': _vm.$route.name.includes('-tickets') }
    ]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }